import useModalAlertCheckMail from './AlertCheckMail/AlertCheckMail';
import useModalForgotPassword from './ForgotPassword/ForgotPassword';
import useModalLogin from './LoginModal/LoginModal';
import useSignUpModal from './SignUpModal/SignUpModal';

const useModalAuth = () => {
  const { openModalLogin } = useModalLogin();
  const { openModalSignUp } = useSignUpModal();
  const { openModalForgotPassword } = useModalForgotPassword();
  const { openModalAlertCheckMail } = useModalAlertCheckMail();

  const openLogin = onClose => {
    openModalLogin({
      onOpenSignUp: () => {
        openSignUp();
      },
      onOpenForgotPassword: () => {
        openForgotPassword();
      },
      onClose,
    });
  };
  const openSignUp = () => {
    openModalSignUp({
      onOpenLogin: () => {
        openLogin();
      },
    });
  };
  const openForgotPassword = () => {
    openModalForgotPassword({
      onOpenLogin: () => {
        openLogin();
      },
      onOpenAlertCheckMail: email => {
        openAlertCheckMail(email);
      },
    });
  };
  const openAlertCheckMail = email => {
    openModalAlertCheckMail({
      email,
      openLogin,
    });
  };
  return { openLogin, openSignUp, openForgotPassword, openAlertCheckMail };
};

export default useModalAuth;
